import { Component, inject, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslocoPipe } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { GreentripperPinIconComponent } from '../greentripper-pin-icon/greentripper-pin-icon.component';
import { PackLimitationsService } from '../../services/pack-limitations.service';

@Component({
  selector: 'app-demo-cta',
  imports: [
    ButtonModule,
    TranslocoPipe,
    TooltipModule,
    GreentripperPinIconComponent,
  ],
  templateUrl: './demo-cta.component.html',
})
export class DemoCtaComponent {
  private readonly STORAGE_KEY = 'demo-cta-dismissed-date';
  private packLimitationsService = inject(PackLimitationsService);

  isDiscovery = this.packLimitationsService.isDiscovery;
  isDismissed = signal(this.checkIfDismissedToday());

  openContactModal() {
    this.packLimitationsService.openModal();
  }

  dismiss(): void {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem(this.STORAGE_KEY, today);
    this.isDismissed.set(true);
  }

  private checkIfDismissedToday(): boolean {
    const dismissedDate = localStorage.getItem(this.STORAGE_KEY);
    if (!dismissedDate) return false;

    const today = new Date().toISOString().split('T')[0];
    return dismissedDate === today;
  }
}
